const words = [
  "Always At Your Service",
  "Exceptional Craftsmanship",
  "Premium Quality",
  "Unparalleled Excellence",
  "Where Perfection Meets The Road",
];

export default function Marquee() {
  const line = words.join("  ·  ");
  return (
    <section
      aria-hidden="true"
      className="py-10 md:py-14 border-y border-white/5 bg-[#050505] overflow-hidden"
    >
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div
            key={k}
            className="shrink-0 pr-16 font-serif italic text-3xl md:text-5xl lg:text-6xl text-neutral-300 whitespace-nowrap"
          >
            {line} &nbsp;·&nbsp;
          </div>
        ))}
      </div>
    </section>
  );
}
